import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { Tag } from "@design-system/Tag/Tag";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import styles from "./AccrualConfirmButton.module.scss";

interface AccrualConfirmButtonProps {
    label: string;
    changeCount?: number;
    onClick: () => void;
    disabled: boolean;
}

/**
 * Row Confirm / Match action. The badge counts the suggested fields the click
 * will write, so the user knows how much of the row it settles. Without a
 * `changeCount` it renders the plain button.
 */
export const AccrualConfirmButton = ({
    label,
    changeCount,
    onClick,
    disabled,
}: AccrualConfirmButtonProps) => {
    const hasChangeCount = changeCount !== undefined;

    return (
        <Button
            variant="primary"
            size="md"
            onClick={onClick}
            disabled={disabled}
            className={classNames(viewTableStyles.showOnHover, {
                [styles.button]: hasChangeCount,
            })}
            rightIcon={
                hasChangeCount ? (
                    <span data-slot-box="">
                        <Tag
                            size="xs"
                            numeric
                            color="accent"
                            data-testid="accrual-change-count"
                        >
                            {changeCount}
                        </Tag>
                    </span>
                ) : undefined
            }
        >
            {label}
        </Button>
    );
};
